/**
 * Normalize a trading pair symbol for comparison by stripping:
 * - Exchange/DEX prefixes (e.g. "XYZ:BRENTOIL" → "BRENTOIL")
 * - "-PERP" and "-SWAP" suffixes
 * - Settlement suffix after the quote (e.g. "/USDC:USDC" → "/USDC")
 * - Whitespace
 *
 * Examples:
 *   "XYZ:BRENTOIL/USDC:USDC" → "BRENTOIL/USDC"
 *   "ETH-PERP" → "ETH"
 *   "BTC/USDT" → "BTC/USDT"
 */
export function normalizeSymbol(symbol: string): string {
  // Strip exchange prefix (e.g. "XYZ:"), then -PERP/-SWAP suffixes, then whitespace
  const stripped = symbol
    .replace(/^[a-zA-Z]+:/, "")
    .replace(/-PERP$/, "")
    .replace(/-SWAP$/, "")
    .replace(/\s+/g, "")
    .toUpperCase();

  // Remove settlement suffix after the quote (e.g. "/USDC:USDC" → "/USDC")
  const slashIdx = stripped.indexOf("/");
  if (slashIdx !== -1) {
    const colonIdx = stripped.indexOf(":", slashIdx);
    if (colonIdx !== -1) {
      return stripped.slice(0, colonIdx);
    }
  }
  return stripped;
}
